// External Dependencies
import React from 'react';
import SvgIcon from 'material-ui/SvgIcon';

const LocationIcon = props => (
  <SvgIcon viewBox="0 0 64 64" {...props}>
    <g id="Layer_1">
      <g>
        <circle
          cx="32"
          cy="32"
          fill="#76C2AF"
          r="32"
        />
      </g>
      <g opacity="0.2">
        <g>
          <path
            d="M32,14c-9.389,0-17,7.522-17,16.8C15,45.5,32,56,32,56s17-10.237,17-25.2C49,21.522,41.389,14,32,14zM32,38c-4.418,0-8-3.582-8-8s3.582-8,8-8s8,3.582,8,8S36.418,38,32,38z"
            fill="#231F20"
          />
        </g>
      </g>
      <g>
        <path
          d="M32,12c-9.389,0-17,7.522-17,16.8C15,43.5,32,54,32,54s17-10.237,17-25.2C49,19.522,41.389,12,32,12zM32,36c-4.418,0-8-3.582-8-8s3.582-8,8-8s8,3.582,8,8S36.418,36,32,36z"
          fill="#FFFFFF"
        />
      </g>
    </g>
    <g id="Layer_2" />
  </SvgIcon>
);

export default LocationIcon;



/** WEBPACK FOOTER **
 ** ./src/shared/icons/location.js
 **/